import fareItemCardWithoutBackgroundImage from './fareItemCardWithoutBackgroundImage';
import fareItemCardBackgroundImageMediumFull from './fareItemCardBackgroundImageMediumFull';
import fareItemCardBackgroundImageMediumFullMiles from './fareItemCardBackgroundImageMediumFullMiles';
import fareItemCardBackgroundImageTallSimple from './fareItemCardBackgroundImageTallSimple';
import fareItemCardBackgroundImageTallSimpleCentered from './fareItemCardBackgroundImageTallSimpleCentered';
import fareItemCardBackgroundImageTallOverlaySimpleCenteredMiles from './fareItemCardBackgroundImageTallOverlaySimpleCenteredMiles';
import fareItemCardBackgroundImageSmallOverlaySimpleCentered from './fareItemCardBackgroundImageSmallOverlaySimpleCentered';
import fareItemCardCurrencyCard from './fareItemCardCurrencyCard';
import fareItemCardCurrencyCardMobile from './fareItemCardCurrencyCardMobile';
import fareItemCardMilesCard from './fareItemCardMilesCard';
import fareItemCardHeroCard from './fareItemCardHeroCard';
import fareItemCardHeroCardMobile from './fareItemCardHeroCardMobile';
import fareItemCardHeroCardLover from './fareItemCardHeroCardLover';
import fareItemCardCurrencyCardLover from './fareItemCardCurrencyCardLover';
import fareItemCardCurrencyCardLight from './fareItemCardCurrencyCardLight';

const flavors = {
  fareItemCardWithoutBackgroundImage,
  fareItemCardBackgroundImageMediumFull,
  fareItemCardBackgroundImageMediumFullMiles,
  fareItemCardBackgroundImageTallSimple,
  fareItemCardBackgroundImageTallSimpleCentered,
  fareItemCardBackgroundImageTallOverlaySimpleCenteredMiles,
  fareItemCardBackgroundImageSmallOverlaySimpleCentered,
  fareItemCardCurrencyCard,
  fareItemCardCurrencyCardMobile,
  fareItemCardMilesCard,
  fareItemCardHeroCard,
  fareItemCardHeroCardMobile,
  fareItemCardHeroCardLover,
  fareItemCardCurrencyCardLover,
  fareItemCardCurrencyCardLight,
};

export default flavors;
